import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as StoreModelActions from '../_actions/storeModel';
import { StoreModel } from '../_models';

export interface StoreModelState extends EntityState<StoreModel> {
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const adapter: EntityAdapter<StoreModel> = createEntityAdapter<StoreModel>({
  selectId: (storeModel) => storeModel.roleGranted, // Replace `customId` with the actual unique identifier property
});

const initialState: StoreModelState = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

const StoreModelReducer = createReducer(
  initialState,

  on(StoreModelActions.loadStoreModels, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(StoreModelActions.loadStoreModelsSuccess, (state, { storeModels }) =>
    adapter.setAll(storeModels, { ...state, loading: false, loaded: true })
  ),

  on(StoreModelActions.loadStoreModelsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  }))
);

export function reducer(state: StoreModelState | undefined, action: Action) {
  return StoreModelReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
